import React from 'react';
import Home from '../components/home/home';
import HomeLayout from '../components/home/home-layout';

const HomePage: React.FC = () => {
  return (
     <HomeLayout children={<Home/>}></HomeLayout>
  );
};

export default HomePage;